
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 1.714A4.256 4.256 0 002.98 2.972l-.886-.886-.379 2.622 2.656-.345-.889-.888a3.551 3.551 0 012.52-1.046A3.575 3.575 0 019.57 6a3.575 3.575 0 01-3.57 3.571 3.572 3.572 0 01-3.176-1.943L2.212 8A4.286 4.286 0 106 1.714z","fill":"#fff"}})])
          )
        }
      }
    